import { cn } from "../lib/utils";

interface BrandProps {
  compact?: boolean;
  inverted?: boolean;
  className?: string;
}

export function Brand({ compact = false, inverted = false, className }: BrandProps) {
  return (
    <div className={cn("flex min-w-0 items-center gap-3", className)}>
      <span className="relative block size-11 shrink-0 overflow-hidden rounded-[13px] bg-[#f3f3f1] ring-1 ring-black/8">
        <img
          src="/hyper-profits-logo.png"
          alt=""
          aria-hidden="true"
          className="size-full scale-[1.55] object-cover object-center"
        />
      </span>
      {!compact && (
        <span className="min-w-0">
          <span className={cn("font-display block truncate text-[15px] font-bold tracking-[-0.025em]", inverted ? "text-white" : "text-foreground")}>
            Hyper Profits
          </span>
          <span className={cn("block truncate text-[11px]", inverted ? "text-rail-muted" : "text-muted-foreground")}>
            ETH/USD control room
          </span>
        </span>
      )}
    </div>
  );
}
